export enum eChartsAlign {
    left = 'left', // Seems like the best choice much of the time.
    center = 'center',
    right = 'right'
}
